export function buildQueryString(params: Record<string, unknown>): string {
  const parts: string[] = []
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue
    const str = typeof v === 'boolean' ? (v ? 'true' : 'false') : String(v)
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(str)}`)
  }
  return parts.length ? `?${parts.join('&')}` : ''
}
